$(document).ready(function() {
  // Ensure elements exist before initializing
  if ($('.spotlight-slider').length && $('.prev-slide').length && $('.next-slide').length) {
    $('.spotlight-slider').slick({
      slidesToShow: 2.5, 
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      autoplaySpeed: 5000,
      infinite: false,
      prevArrow: $('.prev-slide'),
      nextArrow: $('.next-slide'),
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
            arrows: true,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
            arrows: true,
          }
        }
      ]
    });
  }
});



    document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', () => {
      question.classList.toggle('active');
      const answer = question.nextElementSibling;
      if (answer.style.display === "block") {
        answer.style.display = "none";
      } else {
        answer.style.display = "block";
      }
    });
  });

document.addEventListener("DOMContentLoaded", function () {
  function initMobileSlider() {
    if (window.innerWidth <= 767 && !document.querySelector('.featured-in-wrapper').classList.contains('slick-initialized')) {
      $('.featured-in-wrapper').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: false,
        infinite: true
      });
    }
  }

  initMobileSlider();

  // Re-check on resize (optional)
  window.addEventListener('resize', function () {
    if (window.innerWidth <= 767) {
      initMobileSlider();
    } else {
      if ($('.featured-in-wrapper').hasClass('slick-initialized')) {
        $('.featured-in-wrapper').slick('unslick');
      }
    }
  });
});


// ------ Product-page-related-product-slider -------

  //  $('.related-bg-section ul.product-grid').slick({
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   dots: false,
  //   autoplay: false,
  //   autoplaySpeed: 5000,
  //   infinite: false,
  //   prevArrow: $('.prev-slide'),
  //   nextArrow: $('.next-slide'),
  //   responsive: [
  //     {
  //       breakpoint: 991,
  //       settings: {
  //         slidesToShow: 1.5,
  //         slidesToScroll: 1,
  //         arrows: true,
  //       }
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         slidesToShow: 1.5,
  //         slidesToScroll: 1,
  //         arrows: true,
  //       }
  //     }
  //   ]
  // });


// ------ End ------


document.querySelectorAll("details").forEach((el) => {
  const summary = el.querySelector("summary");
  const content = el.querySelector(".accordion__content");

  if (!summary || !content) return;

  el.setAttribute("is-animated", "");
  if (el.hasAttribute("open")) {
    content.style.height = content.scrollHeight + "px";
    setTimeout(() => {
      content.style.height = "auto";
    }, 400);
  }

  summary.addEventListener("click", (e) => {
    e.preventDefault();

    const isOpen = el.hasAttribute("open");

    if (isOpen) {
      content.style.height = content.scrollHeight + "px";
      requestAnimationFrame(() => {
        content.style.height = "0px";
      });

      setTimeout(() => {
        el.removeAttribute("open");
      }, 400);
    } else {
      el.setAttribute("open", "");
      const height = content.scrollHeight;
      content.style.height = "0px";

      requestAnimationFrame(() => {
        content.style.height = height + "px";
      });

      setTimeout(() => {
        content.style.height = "auto"; 
      }, 400);
    }
  });
});
$(document).ready(function(){
  $('.slider-rings .product-grid ').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});

